<template>
	<vs-dialog prevent-close v-model="active" @close="borrar">
		<template #header>
			<h4 class="not-margin">
				Registrar cartera vencida de SIM
			</h4>
		</template>


		<div class="con-form">
			<form autocomplete="off" v-on:submit.prevent>
				<vs-col w="12">
					<label for="cicloEscolar" class="labelInput">
						Ciclo Escolar
					</label>
					<p style="padding: 0 0 0 10px; " class="mb-0" v-if="cicloEscolarAnterior && cicloEscolarAnterior.ciclo_anterior && cicloEscolarAnterior.ciclo_anterior.nombre_ciclo"><strong>{{cicloEscolarAnterior.ciclo_anterior.nombre_ciclo}}</strong></p>
					<p v-else :loading="loadingPrograma">Cargando</p>
				</vs-col>
				<vs-col w="12">
					<label for="programa" class="labelInput">
						Programa
					</label>
					<vs-select class="pt-0" :loading="loadingPrograma" filter placeholder="Programa" v-model="programa" :key="programaId">
						<template #message-danger v-if="errorFields.includes('programa')">
							Requerido
						</template>
						<template>
							<vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
								{{option.text}}
							</vs-option>
						</template>
					</vs-select>
				</vs-col>
				<vs-col w="12">
					<label for="codigo_detalle_id" class="labelInput">
						Código de detalle
					</label>
					<vs-select disabled class="aqui pt-0" id="codigo_detalle_id" placeholder="Seleccionar código de detalle" v-model="codigo_detalle_id">
					<template #message-danger v-if="errorFields.includes('codigo_detalle_id')">
						Requerido
					</template>
						<vs-option label="Cartera vencida desde el SIM" value="121">
							Cartera vencida desde el SIM
						</vs-option>
					</vs-select>
				</vs-col>
				<vs-col>
					<label for="monto" class="labelInput">
						Fecha de cartera vencida
					</label>
					<vs-input
						class="pt-0"
						type="date"
						v-model="fecha_vigencia_aplicacion"
					>
						<template #message-danger v-if="errorFields.includes('fecha_vigencia_aplicacion')">
							Requerido
						</template>
					</vs-input>
				</vs-col>
				<vs-col>
					<label for="monto" class="labelInput">
						Monto
					</label>
					<vs-input class="pt-0" type="number" v-model="monto" placeholder="Monto">
						<template #message-danger v-if="errorFields.includes('monto')">
							Requerido
						</template>
					</vs-input>
				</vs-col>
			</form>
		</div>
		<template #footer>
			<div class="footer-dialog d-flex">
				<vs-button danger block @click="borrar()" style="width: 30%;">
				Cancelar
				</vs-button>
				<vs-button success class="ml-auto" block @click="getRegistrarCarteraVencida()" style="width: 30%;">
				Aceptar
				</vs-button>
			</div>
		</template>	
	</vs-dialog>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
import profesor from '../../../../../api/requests/landing-profesor'
export default {
	props:[
		'value',
		'filtros',
		'row',
		'personaId'
	],
	data () {
		return {
			active: false,
			errorFields: [],
			cicloEscolar: '',
			cicloEscolarAnterior: {},
			loadingCicloEscolar: false,
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
			loadingPrograma: false,
			codigo_detalle_id: '121',
			fecha_vigencia_aplicacion: '',
			monto: ''
		}
	},
	methods: {
		borrar(){
			this.ciclo_escolar_id = ''
			this.programa_id = ''
			this.monto = ''
			this.fecha_vigencia_aplicacion = ''
			this.active = false
		},
		async getCicloAnterior(){
			try{
				this.loadingCicloEscolar = true
				const { data: response } = await reportes.getCicloAnterior(this.filtros.cicloEscolar)
				this.loadingCicloEscolar = false
				this.cicloEscolarAnterior = response
			}catch{
				this.loadingCicloEscolar = false
			}
		},
        async getProgramas () {
            if (this.filtros.institucion && this.filtros.cicloEscolar){
				this.loadingPrograma = true
				let params = {
					institucion_id: this.filtros.institucion,
					persona_id: this.personaId,
					ciclo_escolar_id: this.filtros.cicloEscolar,
				}
				console.log('personaid' + this.personaId)
				const { data: response } = await profesor.getPrograma(params) || {}
				const { opciones: programas, default:val } = response || {}
					if (programas){
						this.loadingPrograma = false
						this.programas = Object.values(programas)
						this.programa = val
						this.programaDefault = val
						this.programaId = (new Date()).getTime()
					}
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.codigo_detalle_id) {
                this.errorFields.push('codigo_detalle_id')
            }
            if (!this.monto) {
                this.errorFields.push('monto')
            }
            if (!this.fecha_vigencia_aplicacion) {
                this.errorFields.push('fecha_vigencia_aplicacion')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
		async getRegistrarCarteraVencida(){
			if(this.sanityForm()){
                const loading = this.$vs.loading()
				try{
					const params = {
						persona_id: this.personaId,
						institucion_id: this.filtros.institucion,
						ciclo_escolar_id: this.cicloEscolarAnterior.ciclo_anterior.id,
						programa_id: this.programa,
						codigo_detalle_id: this.codigo_detalle_id,
						tipo_cargo: 'registro_cartera_vencida_sim',
						fecha_vigencia_aplicacion: this.fecha_vigencia_aplicacion,
						monto: this.monto
					}
                    const { data: response } = await reportes.getRegistrarCarteraVencida(params)
					loading.close()	
					this.$vs.notification({
						progress: 'auto',
						duration: 5000,
						color: 'success',
						position: null,
						title: 'Se registró correctamente la información',
					})
					this.borrar()
					this.$emit('refreshTable')

				}catch(error){
					loading.close()
					this.$vs.notification({
						progress: 'auto',
						duration: 5000,
						color: 'danger',
						position: null,
						title: 'Hubo un error',
						text: 'Por favor contecte al administrador'
					})
				}
			}
		}
  	},
	watch: {
		value (val) {
  			this.active = val
		},
		async active (val) {
			if (!val){
				this.$emit('input', val);
			}
		},
		filtros(){
			this.getCicloAnterior()
		},
		row(){
			this.getProgramas()
		}
	}
}
</script>